// import React from 'react';
// import { Helmet } from 'react-helmet-async';
// import '../styles/HomeComponents/AboutUs.css'; // Make sure this path matches your project structure

// const AboutUs = () => {
//   return (
//     <div className="about-page">
//        <Helmet>
//         <title>About Strawket | Our Story, Mission & Purpose</title>
//         <meta 
//           name="description" 
//           content="Discover Strawket's journey — from a shared vision to a full academy operating system that connects passionate educators with curious learners." 
//         />
//         <meta 
//           name="keywords" 
//           content="About Strawket, Strawket story, Strawket mission, edtech platform, academy operating system, educators and learners, student platform" 
//         />
//         <link rel="canonical" href="https://www.strawket.com/about" />

//         {/* Open Graph (Facebook, LinkedIn, etc.) */}
//         <meta property="og:title" content="About Strawket | A Platform Built on Passion for Learning" />
//         <meta 
//           property="og:description" 
//           content="Learn how Strawket was built to unburden educators, empower learners, and simplify running an academy. Real pain points. Real solutions." 
//         />
//         <meta property="og:url" content="https://www.strawket.com/about" />
//         <meta property="og:type" content="website" />
//         <meta property="og:image" content="https://www.strawket.com/assets/images/strawket-about-preview.png" />

//         {/* Twitter Card */}
//         <meta name="twitter:title" content="About Strawket | Built for Educators & Learners" />
//         <meta 
//           name="twitter:description" 
//           content="Discover the story behind Strawket — a platform that simplifies education by connecting passionate educators with learners worldwide." 
//         />
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:image" content="https://www.strawket.com/assets/images/strawket-about-preview.png" />
//       </Helmet>
//       <header className="about-header">
//         <h1>About Strawket</h1>
//         <p>Connecting Passionate Educators with Curious Learners</p>
//       </header>

//       <section className="about-section">
//         <div className="container">
//           <p>
//             Strawket was born from the founding team’s vision of helping people follow their passion. Here is our origin story.
//           </p>
//           <p>
//             While we were working on building an academy, we spent hundreds of hours speaking with learners and educators to understand how we can help them better. A few insights stood out as everyone kept telling us the same pain points again and again… and again!
//           </p>
//           <p>
//             We found that Educators (or instructors or coaches or teachers) are all really passionate about teaching and what they are teaching. What they really do not like is the administrative stuff that is unfortunately essential when running a well-oiled academy. Another barrier for them was the big question of how they will get their students in the first place — aka, marketing.
//           </p>
//           <p>
//             This was a real pain for passionate educators and many did not even start off because they were intimidated by admin and marketing so much! To us, this sounded like a big miss because there were so many learners out there who could benefit from passionate educators!
//           </p>
//           <p>
//             In the early days, we were focused on kids and so, we spoke with many of their parents. Interestingly, we found parents asking us what else we offered! While this was validation for our model, it also told us that parents were struggling to find the right instructors for their child’s passion. They also wanted to get a simple understanding of what was being taught in class.
//           </p>
//           <p>
//             We knew we could not do everything and wanted to build a community of micro-entrepreneurs to help us carry our vision forward.
//           </p>
//           <p>
//             This was it! From our experience of building a successful academy and hours of conversations, was forged Strawket – a simple Operating System for an Academy.
//           </p>

//           <h2>Our Mission</h2>
//           <ul>
//             <li>Connect curious learners with world-class educators globally.</li>
//             <li>Provide educators with a simple, proven way to run an academy.</li>
//             <li>Empower learners to find the right educators for their passion.</li>
//           </ul>

//           <p>
//             From day one, our goal has remained the same: ignite passion in learners, unburden educators, and foster a vibrant academy ecosystem.
//           </p>

//           <p><strong>Welcome to Strawket — where learning meets passion, and teaching becomes effortless.</strong></p>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default AboutUs;



import React from "react";
import { Helmet } from "react-helmet-async";
import "../styles/HomeComponents/AboutUs.css";

// import your Strawket-style illustrations here
import heroIllustration from "../assets/Images/Group 228.webp";
import activitiesIllustration from "../assets/Images/chess.png";

const AboutUs = () => {
  return (
    <div className="about-page">

      <Helmet>
         <title>About Strawket | Our Story, Mission & Purpose</title>
         <meta 
          name="description" 
          content="Discover Strawket's journey — from a shared vision to a full academy operating system that connects passionate educators with curious learners." 
        />
        <meta 
          name="keywords" 
          content="About Strawket, Strawket story, Strawket mission, edtech platform, academy operating system, educators and learners, student platform" 
        />
        <link rel="canonical" href="https://www.strawket.com/about" />

        {/* Open Graph (Facebook, LinkedIn, etc.) */}
        <meta property="og:title" content="About Strawket | A Platform Built on Passion for Learning" />
        <meta 
          property="og:description" 
          content="Learn how Strawket was built to unburden educators, empower learners, and simplify running an academy. Real pain points. Real solutions." 
        />
        <meta property="og:url" content="https://www.strawket.com/about" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.strawket.com/assets/images/strawket-about-preview.png" />

        {/* Twitter Card */}
        <meta name="twitter:title" content="About Strawket | Built for Educators & Learners" />
        <meta 
          name="twitter:description" 
          content="Discover the story behind Strawket — a platform that simplifies education by connecting passionate educators with learners worldwide." 
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://www.strawket.com/assets/images/strawket-about-preview.png" />
      </Helmet>

      {/* HERO */}
      <section className="about-hero">
        <div className="about-hero-inner">
          <div className="about-hero-text">
            <h1>Why is it so hard to follow your passion?</h1>
            <p>
              Strawket began with a simple question we kept hearing over and over.
            </p>
          </div>

          <div className="about-hero-visual">
            <img src={heroIllustration} alt="Learner and educator conversation" />
          </div>
        </div>
      </section>

      {/* STORY */}
      <section className="about-story">
        <div className="about-container">
          <p>
            Back when we were building our own academy, we spent countless hours
            speaking with learners, parents, and educators. The conversations
            were eye-opening.
          </p>

          <p>
            Educators were deeply passionate about teaching — but overwhelmed by
            everything else… scheduling, reminders, attendance, reports,
            payments, marketing.
          </p>

          <p>
            All the admin work that was supposed to support teaching was actually
            standing in the way of it.
          </p>

          <p>
            Many incredible educators told us they hadn’t even started their
            academy because they were intimidated by the non-teaching parts.
            That felt like a huge loss — not just for them, but for learners who
            would have thrived under their guidance.
          </p>

          <p>
            Parents, on the other hand, kept asking,
            <span className="highlight">
              {" "}
              “Do you offer more? What else can my child learn?”
            </span>
          </p>

          <p>
            They wanted a simple way to find the right teacher — someone who
            truly understood their child’s interests. And they wanted clarity
            about what was being taught, without the usual confusion.
          </p>

          <p className="pattern">
            As we listened, a pattern emerged:
            <br />
            <strong>
              Learners wanted direction. Educators wanted freedom. And both
              needed a bridge to find each other.
            </strong>
          </p>
        </div>
      </section>

      {/* ACTIVITIES */}
      <section className="about-activities">
        <div className="about-container activities-inner">
          <div className="activities-visual">
            <img src={activitiesIllustration} alt="Different learning activities" />
          </div>

          <div className="activities-text">
            <p>
              That’s when the idea for Strawket became clear.
            </p>

            <p>
              We didn’t want to build yet another academy.
            </p>

            <p>
              We wanted to build the platform that empowers passionate educators
              everywhere — giving them the tools to run an academy with ease,
              and helping learners discover the right teacher for their passion.
            </p>

            <p className="closing">
              So we turned our conversations and early learnings into Strawket —
              <strong> a simple operating system for an academy.</strong>
            </p>
          </div>
        </div>
      </section>

      {/* MISSION */}
      <section className="about-mission">
        <div className="about-container">
          <h2>Our Mission</h2>

          <p className="mission-lead">
            At Strawket, our mission is simple:
            <strong> Make it easy for anyone to follow their passion.</strong>
          </p>

          <p>
            We give educators a simple, powerful way to run an academy — so they
            can focus on what they truly love: teaching.
          </p>

          <p>
            And we help learners find the right teacher effortlessly, connecting
            them with mentors who can spark curiosity, confidence, and lifelong
            passion.
          </p>

          <p className="mission-closing">
            Strawket exists to remove the barriers on both sides — unburdening
            educators, empowering learners, and connecting curious learners
            with passionate educators.
          </p>
        </div>
      </section>

    </div>
  );
};

export default AboutUs;

